import apiClient from './client';

const unwrapList = (response) => response.data?.results ?? response.data ?? [];

export const getContacts = async (params) => {
  const response = await apiClient.get('/contacts/', { params });
  return unwrapList(response);
};

export const getB2BContacts = async () => {
  const response = await apiClient.get('/contacts/');
  return response.data?.results ?? response.data ?? [];
};

export const getB2CContacts = async () => {
  const response = await apiClient.get('/contacts/');
  return response.data?.results ?? response.data ?? [];
};

export const getContact = async (contactId) => {
  const response = await apiClient.get(`/contacts/${contactId}/`);
  return response.data;
};

export const createContact = async (payload) => {
  const response = await apiClient.post('/contacts/', payload);
  return response.data;
};

export const markContactRead = async (phone) => {
  const response = await apiClient.patch(`/contacts/${phone}/mark-read/`);
  return response.data;
};

export const bulkUploadContacts = async (payload) => {
  const response = await apiClient.post('/contacts/bulk/', payload);
  return response.data;
};

export const bulkCreateContacts = async (payload) => {
  const response = await apiClient.post('/contacts/bulk/', payload);
  return response.data;
};

export const updateContact = async (contactId, payload) => {
  const response = await apiClient.patch(`/contacts/${contactId}/`, payload);
  return response.data;
};

export const deleteContact = async (contactId) => {
  const response = await apiClient.delete(`/contacts/${contactId}/`);
  return response.data;
};

export const getGroups = async () => {
  const response = await apiClient.get('/contact-groups/');
  return unwrapList(response);
};

export const createGroup = async (payload) => {
  const response = await apiClient.post('/contact-groups/', payload);
  return response.data;
};

export const deleteGroup = async (groupId) => {
  const response = await apiClient.delete(`/contact-groups/${groupId}/`);
  return response.data;
};

export const addContactsToGroup = async (groupId, contactIds) => {
  const response = await apiClient.post(`/contact-groups/${groupId}/add-contacts/`, { contact_ids: contactIds });
  return response.data;
};

export const removeContactsFromGroup = async (groupId, contactIds) => {
  const response = await apiClient.post(`/contact-groups/${groupId}/remove-contacts/`, { contact_ids: contactIds });
  return response.data;
};

export const getInboxConversations = async () => {
  try {
    const response = await apiClient.get('/inbox/conversations/');
    return unwrapList(response);
  } catch (err) {
    console.error('Error fetching inbox conversations:', err);
    return [];
  }
};